export const SPACING_PX = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60] as const

export const SPACING = SPACING_PX.map((value) => `${value}px`)

export const TEXT_SIZING_PX = {
    header: 24,
    title: 20,
    paragraph: 18,
    label: 16,
    sub: 14,
} as const

export const BOX_SHADOW =
    'box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%);'

export const BORDER_RADIUS_PX = 2

export const BORDER_RADIUS = `${BORDER_RADIUS_PX}px`

export const BORDER_RADIUS_LG = `${BORDER_RADIUS_PX * 2}px`

export const TRANSITION_TIME_MD_MS = 500

export const TRANSITION_TIME_FAST_MS = 250
